@if (activeMedia) {
  <div class="active-media" [ngClass]="{'active-media--draggable': zoomValue > 1}">
    <div class="active-media__container">
      @if (objectType === 'Model3D') {
        <div class="model-3d-placeholder">
          <i class="icon-object"></i>
        </div>
      } @else if (validThumbnailSrc && !playMedia && !mediaNotReady) {
        <img
          [src]="imageUrl"
          [alt]="'TRANS__ACTIVE_MEDIA__ACTIVE_MEDIA' | translate"
          id="mediaItem-{{activeMedia.artifact_id}}"
          (error)="setDefaultImg()"
        >
        @if (isPlayable) {
          <a (click)="onPlayMedia()" class="playButton">
            <i class="icon-play2"></i>
          </a>
        }
      } @else if (isPlayable && playMedia) {
        <div
          class="active-media__player-container"
          [class.active-media__player-container--video]="objectType === 'Video' && !showWaveformPlayer"
        >
          @if (showWaveformPlayer) {
            <app-audio-waveform-player
              [playbackUrl]="waveformPlaybackUrl"
              [regions]="segmentRegions"
              [compact]="true"
              [activeRegionId]="activeRegionId"
              [limitPlaybackToActiveRegion]="true"
              [showVideo]="objectType === 'Video'"
            />
          } @else if (objectType === 'Video' && activeMedia?.dms_identifier; as dmsId) {
            <app-dms-video-player
              [dmsApi]="dmsApiUrl"
              [dmsIds]="dmsId"
              [autoplay]="true"
            />
          }
        </div>
      } @else {
        <div class="default-image" role="status">
          @if (objectType === 'Attachment' && !mediaNotReady) {
            <mat-icon class="default-image__icon" aria-hidden="true">{{ attachmentSymbol }}</mat-icon>
            <span>{{ 'TRANS__ACTIVE_MEDIA__NO_ATTACHMENT_IMAGE' | translate }}</span>
          } @else if (showNotReady) {
            <mat-icon class="default-image__icon default-image__not-ready" aria-hidden="true">{{ notReadyIcon }}</mat-icon>
            <span>{{ 'TRANS__ACTIVE_MEDIA__MEDIA_NOT_READY' | translate }}</span>
            @if (conversionStatusKey; as statusKey) {
              <span class="default-image__progress" aria-live="polite">{{ statusKey | translate }}@if (conversionProgress !== null) { {{ conversionProgress }} %}</span>
            }
          } @else if (isPlayable) {
            <!-- The thumbnail failed to load, but the media itself can still be played -->
            <button
              type="button"
              class="playButton default-image__play"
              [attr.aria-label]="'TRANS__AUDIO_PLAYER__PLAY_TOGGLE_BUTTON_TOOLTIP' | translate"
              (click)="onPlayMedia()"
            >
              <i class="icon-play2"></i>
            </button>
          }
        </div>
      }
    </div>
  </div>
}
